module.exports = __webpack_public_path__ + "static/media/logout-icon.d8809d0b.svg";